// @flow
import * as actions from "../constants/actions";
import { actionCreatorsFactory } from "@actionCreator";

export default actionCreatorsFactory(actions);
